export default __webpack_public_path__ + "static/media/writing1.80cc3db1.png";